import {Checkbox, FormControlLabel} from "@mui/material";

export function IgnoreEditsForReview(props: {
    value: boolean;
    onChange(tf: boolean): void;
}) {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    size="small"
                    checked={props.value}
                    onChange={(e) => props.onChange(e.target.checked)}
                />
            }
            label="Skip project review for these changes"
            componentsProps={{typography: {variant: "body2"}}}
        />
    );
}